module.exports = __webpack_public_path__ + "static/media/86gal06.61093703.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/86gal/86gal06.jpg
// module id = 198
// module chunks = 0